import i18n from "src/lang";

export const KEYCONTACT_TITLE = [
    { keyContactTitle: "นาย", id: "Mr", value: 1 },
    { keyContactTitle: "นาง", id: "Mrs", value: 2 },
    { keyContactTitle: "นางสาว", id: "Miss", value: 3 },
];

export const CREDIT_TERM = [
    { creditTerm: i18n.t("masterData.1day"), id: 8 },
    { creditTerm: i18n.t("masterData.3day"), id: 1 },
    { creditTerm: i18n.t("masterData.15day"), id: 2 },
    { creditTerm: i18n.t("masterData.30day"), id: 3 },
    { creditTerm: i18n.t("masterData.45day"), id: 4 },
    { creditTerm: i18n.t("masterData.60day"), id: 5 },
    { creditTerm: i18n.t("masterData.90day"), id: 6 },
    { creditTerm: i18n.t("masterData.120day"), id: 7 },
];

export const CUSTOMER_TYPE = [
    { customerType: "บุคคลธรรมดา", id: 1 },
    { customerType: "นิติบุคคล", id: 2 },
];

export const INSURED_NAME_UNDER = [
    { label: "Company", id: 1 },
    { label: "Individual", id: 2 },
];

export const PURCHASE_FROM = [
    { label: "All Now", id: "All Now" },
    { label: "Other", id: "Other" },
];

export const PAYMENT_TYPE = [
    "cheque", "cash", "bankTransfer", "postpaid"
].map((key, i) => {
    return ({
        paymentType: i18n.t(`masterData.${key}`),
        id: i + 1
    })
}
)

export const SUBCONTRACTOR_TYPE = [
    "company", "individual"
].map((key, i) => {
    return ({
        subcontractorType: i18n.t(`masterData.${key}`),
        id: i + 1
    })
}
)

export const INVOICE_DATE = [
    "Pick up Date", "Delivery Date"
].map((x, i) => {
    return ({
        invoiceDate: x,
        id: i + 1
    })
}
)

export const CUSTOMER_GROUPING_L1 = [
    { customerGroupingL1: "CP ALL", id: 1 },
    { customerGroupingL1: "CP ALL Group", id: 2 },
    { customerGroupingL1: "CPG", id: 3 },
    { customerGroupingL1: "Non-CP Group", id: 4 },
]
export const CUSTOMER_GROUPING_L2 = [
    { customerGroupingL2: "CP ALL", id: 1 },
    { customerGroupingL2: "CP ALL Group", id: 2 },
    { customerGroupingL2: "CPG-CPF", id: 3 },
    { customerGroupingL2: "CPG-CPI", id: 4 },
    { customerGroupingL2: "CPG-Lotus's", id: 5 },
    { customerGroupingL2: "CPG-Marko", id: 6 },
    { customerGroupingL2: "CPG-Orthers", id: 7 },
    { customerGroupingL2: "Non-CP Group", id: 8 },
]
export const MOBILE_COUNTRY_CODES = [66]
export const FORM_FIELD_TYPES = {
    SELECT: 'BaseSelect'
}

export const RULES = {
    COMPANY_TAX_ID: 'required|max:13|digits:13',
    FREIGHT_LICENSE_NUMBER: 'max:20',
    COMPANY_NAME: 'max:150',
    PHONE_NUMBER: 'max:8',
    PERSON_NAME: 'max:30'
}

export const STATUSES = [
    { text: 'All', value: "", key: 'all' },
    { text: 'Active', value: 'active', key: '1' },
    { text: 'Inactive', value: 'inactive', key: '0' },
    { text: 'Pending', value: 'pending', key: '2' },
]
export const DRIVER_LICENSE_CATEGORY = [
    'ส่วนบุคคล', "ส่วนบุคคลตลอดชีพ", "สาธารณะ", "ทุกประเภท"
].map((x, i) => ({
    text: x,
    id: i + 1
}))

export const DRIVER_LICENSE_TYPE = [
    'ท.1', "ท.2", " ท.3", "ท.4",
    "บ.1", "บ.2", "บ.3", "บ.4", "ส่วนบุคคล"
].map((x, i) => ({
    text: x,
    id: i + 1
}))

export const DRIVER_LICENSE_CATEGORIES = [
    "ส่วนบุคคล",
    "ส่วนบุคคลตลอดชีพ",
    "สาธารณะ",
    "ทุกประเภท",
].map((x, i) => ({
    text: x,
    id: i + 1
}))

export const GENDER = [
    "ชาย",
    "หญิง",
    "ไม่ระบุ",
].map((x, i) => ({
    text: x,
    id: i + 1
}))

export const DRIVER_TITLE = [
    "นาย",
    "นาง",
    "นางสาว",
].map((x, i) => ({
    text: x,
    id: i + 1
}))

export const PLATE_COLOR = [
    "แดง",
    "ขาว",
    "เหลือง",
].map((x, i) => ({
    plateColor: x,
    id: i + 1
}))
export const SERVICE_GROUP = [
    "Dry",
    "Chill",
    "Air Condition",
    "Frozen",
    "ImEx",
    "Fresh",
    "Imex(CBT)",
].map((x, i) => ({
    serviceGroup: x,
    id: i + 1
}))

export const WORK_TYPE = [
    "รถหลัก",
    "รถเสริม",
].map((x, i) => ({
    workType: x,
    id: i + 1
}))
export const VEHICLE_INSURANCE = [
    "ประกันภัยรถยนต์ ชั้น 1",
    "ประกันภัยรถยนต์ ชั้น 2",
    "ประกันภัยรถยนต์ ชั้น 3",
    "ประกันภัยรถยนต์ ชั้น 4",
    "ประกันภัยรถยนต์ ชั้น 2+",
    "ประกันภัยรถยนต์ ชั้น 3+"
].map((x, i) => ({
    vehicleInsurance: x,
    id: i + 1
}))

function getYears() {
    let years = [1960];
    const yearNow = new Date().getFullYear();
    for (let i = 1; i < yearNow - 1960; i++) {
        years.push(1960 + i);
    }
    for (let i = 0; i <= 15; i++) {
        years.push(yearNow + i);
    }
    return years;
}

export const VEHICLE_MODEL_YEAR = getYears().map((x, i) => ({
    vehicleModelYear: x,
    id: x
}))

export const VEHICLE_BRAND = [
    "คัมมิ่นส์",
    "เชฟโรเลต",
    "เดวา",
    "โตโยต้า",
    "นิสสัน",
    "ทาทา",
    "เบนซ์",
    "สแกนเนียร์",
    "วอลโว่",
    "มาสด้า",
    "มิตซูบิชิ",
    "มิตซูบิชิฟูโซ่",
    "ฟอร์ด",
    "โฟตอน",
    "ฟูโซ่",
    "ยูดีทรัคส์", "ไอวีโก้",
    "อีซูซุ", "ฮีโน่",
    "อื่นๆ",
].map((x, i) => ({
    vehicleBrand: x,
    id: (i + 1).toString()
}))

export const FUEL_TYPE = [
    "แก๊สโซฮอล 91",
    "แก๊สโซฮอล 95",
    "แก๊สโซฮอล E20",
    "แก๊สโซฮอล E85",
    "แก๊สโซลีน 95",
    "ดีเซล B7",
    "ดีเซล",
    "ดีเซล B20",
    "พรีเมี่ยมดีเซล B7",
    "ไบโอดีเซล",
    "เอ็นจีวี",
    "ซีเอ็นจี",
    "ซูเปอร์เพาเวอร์ GSH95",
    "ไม่ใช้เชื้อเพลิง",
    "LPG"
].map((x, i) => ({
    fuelType: x,
    id: i + 1
}))

export const ACTION_TYPE = [{ text: "Create", id: 0 }, { text: "Edit", id: 1 }]
export default {}


// WEBPACK FOOTER //
// ./src/static/data/masterData.js